import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "Monitoring Ogloba")
], -1)
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = { class: "card-body pt-0" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "badge border-white text-purple-800 bg-purple-200 p-4 ml-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = ["href"]

import Column from "primevue/column";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import {ref, onMounted} from "vue";
import ApiService from "@/_services/api.service";
import swal from "@/_helpers/swal";
import OglobaVoucherStatusModal from "./OglobaVoucherStatusModal.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'MonitoringOglobaOrder',
  setup(__props) {

let rows = ref<number>(10);
const vouchers = Array<Document>();
let tableData = ref<Array<Document>>(vouchers);
let totalRecords = ref<number>(0);
let voucherRefs = ref([]);
let orderSupplierId = ref('test');
const editingRows = ref([]);
const appLegacyUrl = ref();

onMounted(async () => {
    await fetchData('');
     appLegacyUrl.value = process.env.VUE_APP_LEGACY_URL  ;

});


const onRowEditSave = async (event) => {
    const { newData} = event;
    
    if (newData?.alertComment?.length > 50) {
        swal.error("Le commentaire ne peut pas dépasser 50 caractères")
        return;
    }
    
    try {
        await ApiService.post("/admin/order-supplier-alert", {
            orderSupplierUuid: newData.orderSupplierUuid,
            comment: newData.alertComment
        })
        await  swal.success("", "Commentaire modifié");
        location.reload();
    } catch (error) {
        //
    }
};

 function updateAlertStatus(event, row) {
    ApiService.post("/admin/order-supplier-alert", {
        orderSupplierUuid: row.orderSupplierUuid,
        status: parseInt(event.target.value)
    }).then(async ({data}) => {
       await  swal.success("", "Statut modifié");
        location.reload();
    }).catch(({response}) => {
        swal.error(response?.data?.errors[0]?.message);
    });

}

async function fetchData(
    status: ''
) {
    const params = {
        alertStatus: status
    }
    try {
        const {data} = await ApiService.get('admin/monitoring-ogloba-order', {
            headers: {Accept: 'application/ld+json'},
            params: params
        });
        totalRecords.value = data.data['hydra:totalItems'];
        tableData.value = [];
        data.data['hydra:member'].forEach((item) => {
            tableData.value.push(item);
        });
    } catch (error) {
        swal.error('An error occurred while fetching vouchers.');
    }
}


function filterByAlertStatus(event) {
    fetchData(event.target.value);
}

const openVoucherStatusModal = (rowId, vouchers: []) => {
    voucherRefs.value = vouchers;
    orderSupplierId.value = rowId;
    const voucherStatusModal: HTMLDialogElement | null = document.querySelector(`#ogloba-vocher-status-modal`);
    if (voucherStatusModal) {
        voucherStatusModal.showModal();
    }
};

function getLabelStatus(status) {
    switch (status) {
        case 0:
            return 'En attente';
        case 1:
            return 'Préparation';
        case 2:
            return 'Expédiée';
        case 5:
            return 'Remboursée';
        case 8:
            return 'Erreur';
        case 11:
            return 'Envoi partiel';
        default:
            return '';
    }
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(DataTable), {
        value: _unref(tableData),
        rows: _unref(rows),
        editMode: "row",
        editingRows: editingRows.value,
        "onUpdate:editingRows": _cache[0] || (_cache[0] = ($event: any) => ((editingRows).value = $event)),
        onRowEditSave: onRowEditSave,
        class: "p-datatable-custom",
        rowsPerPageOptions: [10,25, 100],
        paginator: ""
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_FormKit, {
                type: "select",
                name: "filterAlertStatus",
                options: [     {label:'Statut du traitement', value:''},
                                { label: 'A traiter', value: '0' },
                                { label: 'En cours', value: '1' },
                                { label: 'Traité', value: '2' },
                            ],
                onChange: filterByAlertStatus
              })
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Column), {
              field: "created",
              header: "Date",
              class: "whitespace-nowrap"
            }),
            _createVNode(_unref(Column), {
              field: "id",
              header: "Numéro de commande",
              class: "whitespace-nowrap"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("a", {
                  href: appLegacyUrl.value+'admin/order/detail/'+slotProps.data.id,
                  class: "p-button-success ml-2",
                  target: "_blank"
                }, [
                  _createVNode(_unref(Button), {
                    size: "small",
                    icon: "pi pi-eye",
                    class: "p-button-eye",
                    style: {"margin-right":"0.5em"},
                    title: "Voir Commande"
                  })
                ], 8, _hoisted_6)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              header: "Statut de la commande",
              class: "whitespace-nowrap"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("div", _hoisted_7, _toDisplayString(getLabelStatus(slotProps.data.orderSupplierState)), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "firstname",
              header: "Utilisateur"
            }, {
              body: _withCtx((slotProps) => [
                _createTextVNode(_toDisplayString(slotProps.data.firstname + ' ' + slotProps.data.lastname) + " ", 1),
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(slotProps.data.email), 1)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "alertMotifs",
              header: "Motif d’alerte",
              class: "whitespace-nowrap"
            }, {
              body: _withCtx((slotProps) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.alertMotifs, (motif) => {
                  return (_openBlock(), _createElementBlock("div", null, " * " + _toDisplayString(motif), 1))
                }), 256))
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "voucherUrls",
              header: "Liens html ou pdf",
              class: "whitespace-nowrap"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.voucherLinks, (link) => {
                    return (_openBlock(), _createElementBlock("li", null, [
                      _createElementVNode("a", {
                        href: link,
                        class: "p-button-success ml-2",
                        target: "_blank"
                      }, [
                        _createVNode(_unref(Button), {
                          size: "small",
                          icon: "pi pi-download",
                          class: "p-button-success",
                          style: {"margin-right":"0.5em"},
                          title: "Télécharger le voucher"
                        })
                      ], 8, _hoisted_9)
                    ]))
                  }), 256))
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "voucherStatus",
              header: "Statut vouchers",
              class: "whitespace-nowrap"
            }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.voucherRefs.length)
                  ? (_openBlock(), _createBlock(_unref(Button), {
                      key: 0,
                      size: "small",
                      icon: "pi pi-eye",
                      class: "p-button-info p-button-eye",
                      style: {"margin-right":"0.5em"},
                      title: "Voir status",
                      onClick: ($event: any) => (openVoucherStatusModal(slotProps.data.id,slotProps.data.voucherRefs))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "alertStatus",
              header: "Statut du traitement",
              class: "whitespace-nowrap"
            }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_FormKit, {
                  type: "select",
                  name: "ssss",
                  modelValue: slotProps.data.alertStatus,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.data.alertStatus) = $event),
                  options: [
                                { label: 'A traiter', value: '0' },
                                { label: 'En cours', value: '1' },
                                { label: 'Traité', value: '2' },
                            ],
                  onChange: ($event: any) => (updateAlertStatus($event,slotProps.data))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              field: "alertComment",
              header: "Commentaire"
            }, {
              editor: _withCtx(({ data, field }) => [
                _createVNode(_component_FormKit, {
                  type: "text",
                  name: field,
                  modelValue: data[field],
                  "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
                  onInput: value => data[field] = value,
                  validation: "length:0,50",
                  "validation-messages": {
                               length: 'Le commentaire ne peut pas dépasser 50 caractères',
                               }
                }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"])
              ]),
              _: 1
            }),
            _createVNode(_unref(Column), {
              rowEditor: true,
              style: {"position":"relative"}
            }),
            _createVNode(_unref(Column), {
              field: "alertUpdatedBy",
              header: "Agent"
            })
          ])
        ]),
        _: 1
      }, 8, ["value", "rows", "editingRows"]),
      _createVNode(OglobaVoucherStatusModal, {
        voucherRefs: _unref(voucherRefs),
        orderSupplierId: _unref(orderSupplierId)
      }, null, 8, ["voucherRefs", "orderSupplierId"])
    ])
  ], 64))
}
}

})